module.exports = __webpack_public_path__ + "img/33.95cdcac9.svg";